module.exports = __webpack_public_path__ + "static/meinthesnowbnw.51d9405b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/meinthesnowbnw.png
// module id = 445
// module chunks = 35783957827783